<template>
  <div>
    <section class="container-fluid bg-alt" style="background-color:white !important;">
      <div class="container">
        <div class="row">
          <div class="col ways3">
            <h2>Our Story</h2>
            <div class="linebreak"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-xs-12">
            <p>AcceleFreight was established in late 2018 with the goal of improving how shipments in freight forwarding are managed for all parties; both customers and service providers. As a startup, we have set out to execute what should have been obvious and done years ago for this industry, to digitize and streamline the entire process.</p>
            <p>
              Our goal is to improve and simplify the customer experience in managing their day-to-day freight import/export requirements. This includes (but not limited to) providing visibility, improving response times, and reducing human errors. Additionally, we aim to provide our service to all customers, large and small, with
              <strong>no additional cost.</strong>
            </p>
          </div>
          <div class="col-sm-6 col-xs-12">
            <p>AcceleFreight is a Malaysian incorporated freight forwarder. We provide services similar to any other freight forwarders, with the addition of a digital platform to track and manage customer shipments. We manage all shipment transactions with other suppliers, so the customer only needs to address us directly for any inquiries or issues regarding their shipments.</p>
            <p>We currently only operate in Malaysia and we accept all shipments going in/out of Malaysia in cooperation with our global partners.</p>
            <p>
              Should you be interested in our services and/or our platform, do feel free to reach out to us at
              <a
                href="mailto:info@accelefreight.com"
              >info@accelefreight.com</a>.
              Alternatively, if you require more information of our other services, you can view them
              <router-link :to="{name: 'webourservices'}">here</router-link>.
              <!-- Alternatively you can also reach out to us at <a href="mailto:info@accelefreight.com">info@accelefreight.com</a> for more information of our services and platform. -->
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid platform aboutus-cityview">
      <!--<h1>Freight Forward</h1>-->
    </section>

    <!--
            <section class="container-fluid platform alt">
                <div class="row">
                    <div class="col col-platform">
                    <h3>Complete control & visibility</h3>
                    <div class="linebreak"></div>
                    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis 
                        natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                    </div>
                    <div class="col-7 screenshot shadow-lg"><img src="images/about-01.jpg" alt="About Us"></div>
                </div>
            </section>

            <section class="container-fluid platform">
                <div class="row">
                    <div class="col col-platform">
                    <h3>Transparent pricing</h3>
                    <div class="linebreak"></div>
                    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis 
                        natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                    </div>
                    <div class="col-7 screenshot shadow-lg"><img src="images/about-02.jpg" alt=""></div>
                </div>
            </section>
    -->
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
